import { render } from "./operations.view.vue?vue&type=template&id=3c923918"
import script from "./operations.view.vue?vue&type=script&lang=js"
export * from "./operations.view.vue?vue&type=script&lang=js"

import "./operations.view.vue?vue&type=style&index=0&id=3c923918&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__